module.exports = __webpack_public_path__ + "static/light-woman-dafcd19ead73f119e5af219c59962806.svg";